import { getAuthHeaders, API_BASE_URL } from './pokemonCardOwnershipService';
import { getAccessToken } from './authService';

export interface StoreEvent {
  id: string;
  title: string;
  description: string;
  date: string;
  time: string;
  location: string;
  type: 'event' | 'tournament';
  entryFee?: string;
  prizes?: string;
  createdAt: string;
}

export type CreateStoreEventInput = Omit<StoreEvent, 'id' | 'createdAt'>;
export type UpdateStoreEventInput = Partial<CreateStoreEventInput>;

export const eventService = {
  // Public
  getUpcomingEvents: async (type?: 'event' | 'tournament'): Promise<StoreEvent[]> => {
    let url = `${API_BASE_URL}/public/events`;
    if (type) {
      url += `?type=${type}`;
    }
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch events');
    const data = await response.json();
    return data.events;
  },

  // Admin
  getAllEvents: async (): Promise<StoreEvent[]> => {
    const token = await getAccessToken();
    const response = await fetch(`${API_BASE_URL}/store/admin/events`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) throw new Error('Failed to fetch events');
    const data = await response.json();
    return data.events;
  },

  createEvent: async (input: CreateStoreEventInput): Promise<StoreEvent> => {
    const token = await getAccessToken();
    const response = await fetch(`${API_BASE_URL}/store/admin/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(input)
    });
    if (!response.ok) throw new Error('Failed to create event');
    const data = await response.json();
    return data.event;
  },

  updateEvent: async (id: string, input: UpdateStoreEventInput): Promise<StoreEvent> => {
    const token = await getAccessToken();
    const response = await fetch(`${API_BASE_URL}/store/admin/events/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(input)
    });
    if (!response.ok) throw new Error('Failed to update event');
    const data = await response.json();
    return data.event;
  },

  deleteEvent: async (id: string): Promise<void> => {
    const token = await getAccessToken();
    const response = await fetch(`${API_BASE_URL}/store/admin/events/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) throw new Error('Failed to delete event');
  }
};
